import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "time_range",
    object: "time_range",
    header: [
      { text: "Name", value: "name" },
      { text: "Hour from", value: "hour_from" },
      { text: "Hour to", value: "hour_to" },
      { text: "Acciones", value: "actions", sortable: false }
    ],
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
